export default __webpack_public_path__ + "static/media/arrow.9fb8e9ae.svg";